import { useArbeitsbereiche } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useArbeitsbereiche/useArbeitsbereiche';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Combobox,
  ComboboxClearItem,
  ComboboxContent,
  ComboboxItem,
  ComboboxList,
  ComboboxOption,
  ComboboxSearch,
  ComboboxTrigger,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ArbeitsbereichSelect({
  value,
  handleChange,
}: {
  value: string;
  handleChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { arbeitsbereiche } = useArbeitsbereiche(currentStandort.id);

  const selectedArbeitsbereich = arbeitsbereiche.find((ab) => ab.id === value);

  const options: ComboboxOption[] = arbeitsbereiche.map((a) => ({
    label: a.name,
    value: a.id,
    color: a.getBorderColor(),
  }));

  return (
    <Combobox
      value={selectedArbeitsbereich?.id ?? ''}
      options={options}
      onValueChange={handleChange}>
      <ComboboxTrigger
        placeholder={t(
          `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.placeholder`,
        )}
      />
      <ComboboxContent
        title={t(
          `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.label`,
        )}>
        <ComboboxSearch
          placeholder={t(
            `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.filterPlaceholder`,
          )}
        />
        <ComboboxList>
          <ComboboxClearItem />
          {arbeitsbereiche.map((option) => (
            <ComboboxItem
              key={option.id}
              option={{
                value: option.id,
                label: option.name,
                color: option.markierung,
              }}
            />
          ))}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
